module.exports = __webpack_public_path__ + "static/media/Device.8a4dd283.png";